export * from './Link';
export { default } from './Link';
//# sourceMappingURL=index.js.map